import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Compiler, COMPILER_OPTIONS, CompilerFactory, ErrorHandler, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { JitCompilerFactory } from '@angular/platform-browser-dynamic';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { InjectableRxStompConfig, RxStompService, rxStompServiceFactory } from '@stomp/ng2-stompjs';
import { BowmanCacheModule } from 'bowman-cache';
import { BowmanCommonsModule } from 'bowman-commons';
import { BowmanLoggerModule } from 'bowman-logger';
import { environment } from '../environments/environment';
import { DynamicModuleService } from '../services/dynamic-module.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthorizationComponent } from './authorization/authorization.component';
import { DashboardDataService } from './dashboard/dashboard-data.service';
import { FlowInspectTableEventDetailsComponent } from './dashboard/flow-inspect/flow-inspect-table-event-details.component';
import { FlowManagementTestComponent } from './data-types/flow-management/flow-management-test/flow-management-test.component';
import { EventDetailsTrayComponent } from './event-details-tray/event-details-tray.component';
import { HeaderComponent } from './header/header.component';
import { GlobalErrorHandler } from './shared/error-handler';
import { CustomRouteReuseStrategy } from './shared/routing-reuse-strategy';
import { SharedModule } from './shared/shared.module';
import { myRxStompConfig } from './shared/stomp-config-factory';


export function createCompiler(compilerFactory: CompilerFactory) {
  return compilerFactory.createCompiler();
}

@NgModule({
  declarations: [
    AuthorizationComponent,
    AppComponent,
    HeaderComponent,
    AuthorizationComponent,
    EventDetailsTrayComponent,
    FlowInspectTableEventDetailsComponent    ,
    FlowManagementTestComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    BowmanCommonsModule,
    BowmanCacheModule,
    BowmanLoggerModule.forRoot({ mainUrl: '/algorilla/api/management/clientLog', isProd: environment.production }),
    SharedModule    
  ],
  providers: [
    DatePipe,
    DecimalPipe,
    DashboardDataService,
    DynamicModuleService,
    { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: COMPILER_OPTIONS, useValue: {}, multi: true },
    { provide: CompilerFactory, useClass: JitCompilerFactory, deps: [COMPILER_OPTIONS] },
    { provide: Compiler, useFactory: createCompiler, deps: [CompilerFactory] },
    { provide: InjectableRxStompConfig, useValue: myRxStompConfig },
    { provide: RxStompService, useFactory: rxStompServiceFactory, deps: [InjectableRxStompConfig] }



  ],

  exports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    BowmanCommonsModule,
    EventDetailsTrayComponent,
    FlowInspectTableEventDetailsComponent

  ],
  bootstrap: [
    AuthorizationComponent
  ]

})
export class AppModule { }

